export const forensicMedicalExaminationConst = {
  path: "/single-programs/forensic-medical-examination",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – СУДЕБНО-МЕДИЦИНСКАЯ ЭКСПЕРТИЗА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Судебно-медицинская экспертиза — точная наука на пересечении медицины и права</h2>
      <p>
        Судебно-медицинская экспертиза — это направление, в котором медицина служит инструментом правосудия. Специалисты в этой области
        изучают причины смерти, механизмы травм, следы насилия, отравления, установление личности, а также оценивают степень тяжести вреда
        здоровью. Их заключения часто становятся ключевыми в уголовных и гражданских делах.
      </p>
      <p>
        Эта профессия требует предельной точности, высокой ответственности и готовности работать с самыми сложными случаями. При этом она
        предлагает уникальный синтез клинических знаний, аналитики и глубокого понимания человеческого организма.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Танатология — наука о смерти</li>
        <li>Судебная патология и травматология</li>
        <li>Токсикология и методы обнаружения ядов</li>
        <li>Медицинская криминалистика</li>
        <li>Основы права и судебного делопроизводства</li>
        <li>Идентификация личности и ДНК-экспертиза</li>
        <li>Судебная психиатрия и сексология</li>
        <li>Подготовка заключений и работа в суде</li>
      </ul>
      <p>
        Значительная часть программы включает практику: изучение реальных экспертных случаев, моделирование экспертиз, взаимодействие с
        юристами и органами следствия.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Судебно-медицинский эксперт при бюро СМЭ</li>
        <li>Патологоанатом-эксперт</li>
        <li>Консультант в правоохранительных органах и судах</li>
        <li>Преподаватель или научный сотрудник</li>
        <li>Специалист по медицинским расследованиям в международных организациях</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€55,000 до €100,000 в год,</strong> в зависимости от специализации и страны.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Обучение у действующих экспертов с судебной практикой</li>
        <li>Возможность стажировок в лабораториях ЕС</li>
        <li>Современные технологии: виртуальные аутопсии, цифровая реконструкция</li>
        <li>Образование с международным признанием</li>
        <li>Комбинация медицинских и юридических дисциплин</li>
        <li>Поддержка на всех этапах — от поступления до трудоустройства</li>
      </ul>
      <p>
        <strong>
          Судебно-медицинская экспертиза — это профессия, где каждое заключение имеет вес закона, а знания врача могут изменить судьбу дела.
        </strong>
      </p>
      <h2>Как поступить?</h2>
      <p>
        Сделать первый шаг просто — заполните заявку, и приёмная комиссия поможет подобрать подходящий формат обучения, собрать документы и
        начать карьеру в уникальной и востребованной области.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Судебно-медицинская экспертиза — точная наука на пересечении медицины и права
    Судебно-медицинская экспертиза — это направление, в котором медицина служит инструментом правосудия. Специалисты в этой области изучают причины смерти, механизмы травм, следы насилия, отравления, установление личности, а также оценивают степень тяжести вреда здоровью. Их заключения часто становятся ключевыми в уголовных и гражданских делах.
    Эта профессия требует предельной точности, высокой ответственности и готовности работать с самыми сложными случаями. При этом она предлагает уникальный синтез клинических знаний, аналитики и глубокого понимания человеческого организма.

    Что вы будете изучать?
    • Танатология — наука о смерти
    • Судебная патология и травматология
    • Токсикология и методы обнаружения ядов
    • Медицинская криминалистика
    • Основы права и судебного делопроизводства
    • Идентификация личности и ДНК-экспертиза
    • Судебная психиатрия и сексология
    • Подготовка заключений и работа в суде
    Значительная часть программы включает практику: изучение реальных экспертных случаев, моделирование экспертиз, взаимодействие с юристами и органами следствия.

    Кем можно работать после окончания?
    • Судебно-медицинский эксперт при бюро СМЭ
    • Патологоанатом-эксперт
    • Консультант в правоохранительных органах и судах
    • Преподаватель или научный сотрудник
    • Специалист по медицинским расследованиям в международных организациях

    Средний доход в Европе:
    от €55,000 до €100,000 в год, в зависимости от специализации и страны.

    Почему выбирают нас?
    • Обучение у действующих экспертов с судебной практикой
    • Возможность стажировок в лабораториях ЕС
    • Современные технологии: виртуальные аутопсии, цифровая реконструкция
    • Образование с международным признанием
    • Комбинация медицинских и юридических дисциплин
    • Поддержка на всех этапах — от поступления до трудоустройства

    Судебно-медицинская экспертиза — это профессия, где каждое заключение имеет вес закона, а знания врача могут изменить судьбу дела.

    Как поступить?
    Сделать первый шаг просто — заполните заявку, и приёмная комиссия поможет подобрать подходящий формат обучения, собрать документы и начать карьеру в уникальной и востребованной области.
  `,
};
